module.exports = __webpack_public_path__ + "img/Green_Logo.05fa39b3.jpg";